// CustomButton.js
import React from "react";
import { Button } from "antd";
import styled from "styled-components";
import { green } from "../constants/colors";

const StyledButton = styled(Button)`
  // width: 100%;
  // height: ${({ small }) => (small ? `40px` : "48px")} !important;

  border: ${({ border }) => (border ? `1px solid gray` : "none")} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  &:hover {
    background-color: ${green} !important;
    color: unset !important;
  }

  // &:focus {
  //   background-color: #40a9ff;
  // }
`;

const CustomButton = ({ onClick, style, children, border, small, ...rest }) => (
  <StyledButton
    style={{ ...style }}
    onClick={onClick}
    border={border}
    small={small}
    {...rest}
  >
    {children}
  </StyledButton>
);

export default CustomButton;
